import _defineProperty from "/home/runner/work/partner-forms-ui/partner-forms-ui/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import * as React from 'react';
import classNames from 'classnames';
var Icon = function Icon(_ref) {
  var iconMarkup = _ref.iconMarkup,
    iconName = _ref.iconName,
    expand = _ref.expand;
  var componentClass = classNames("iq-icon", _defineProperty(_defineProperty({}, "iq-icon--".concat(iconName), !!iconName), "iq-icon--expand", !!expand));
  return /* @__PURE__ */React.createElement("div", {
    className: componentClass,
    dangerouslySetInnerHTML: {
      __html: iconMarkup
    }
  });
};
export { Icon as default };